<template>
  <div>
    <Titulo texto="SISTEMA DE ADMISIÓN ESCOLAR" />
    <div
      class="bg-white d-flex align-items-center justify-content-center px-2 py-4 p-lg-5 border border-2 border-azul-claro2 mx-3"
    >
      <div class="text-center">
        <FontAwesomeIcon icon="check" class="fa-3x text-success" />
        <div class="h3 text-success font-weight-bold mt-4">
          Comprobante descargado
        </div>
        <div
          class="p-3 m-2 col-auto alert alert-warning justify-content-center h5 d-none d-lg-block mt-4"
        >
          Ubica tu comprobante en la
          <strong>carpeta de descargas</strong> de tu navegador
        </div>
        <div
          class="p-3 m-2 col-auto alert alert-warning justify-content-center h5 d-block d-lg-none mt-4"
        >
          Ubica tu comprobante en las
          <strong>descargas</strong> de tu móvil
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PdfDocument } from "@/utils/pdfMake/constructorPDF";
import Titulo from "@/components/generales/Titulo";
import ApiResultado from "@/service/ApiResultado.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCheck);

export default {
  name: "DescargarResultado",
  components: {
    Titulo,
    FontAwesomeIcon
  },
  data() {
    return {
      jwt: "",
      resultadoData: {},
      url: window.location.origin
    };
  },
  mounted() {
    this.comprobarJWT();
  },
  methods: {
    comprobarJWT() {
      this.jwt = this.$route.query.resultado;
      this.resultadoData = this.$route.params.datos;
      if (!this.resultadoData || this.resultadoData === "") {
        console.log("comprobar jwt if " + this.resultadoData);
        this.validarComprobante();
      } else {
        console.log("comprobar jwt else " + this.resultadoData);
        this.generateComprobante(this.resultadoData);
      }
    },
    async validarComprobante() {
      if (this.jwt) {
        let validar = await ApiResultado.validarResultado(this.jwt, this);
        if (validar) {
          console.log("validar comrpobante " + validar);
          this.generateComprobante(validar);
        } else {
          this.$router.push({
            name: "ValidarResultado",
            query: {
              resultado: this.jwt
            }
          });
        }
      } else {
        this.$emit(
          "onError",
          "Ha ocurrido un error en el proceso. Vuelva a intentarlo.",
          "ERROR DE AUTORIZACIÓN",
          true,
          "Sae",
          "SISTEMA DE ADMISIÒN ESCOLAR"
        );
      }
    },
    generateComprobante(datos) {
      let nombreDocumento = `Comprobante Resultado ${datos.postulante.run}-${
        datos.postulante.dv
      }`;
      PdfDocument.init(datos);
      PdfDocument.setFolio(datos.id);
      switch (datos.tipoAsignacion) {
        case "ALGORITMO_PRIMERA_PREFERENCIA":
        case "ALGORITMO_PRIMERA_PREFERENCIA_BLOQUE":
        case "ALGORITMO_PREFERENCIA_N":
        case "ALGORITMO_PREFERENCIA_N_BLOQUE":
        case "MATRICULA_ASEGURADA_PRIMERA_PREFERENCIA":
        case "MATRICULA_ASEGURADA_PREFERENCIA_N":
        case "MATRICULA_ASEGURADA_PRIMERA_PREFERENCIA_BLOQUE":
        case "MATRICULA_ASEGURADA_PREFERENCIA_N_BLOQUE":
        case "CORRE_LISTA_ESPERA_SIN_ASIGNACION":
          if (datos.estado === "RECHAZADO") {
            datos.periodo = 4;
            this.cabeceraComprobante(
              "RECHAZO DEL ESTABLECIMIENTO ASIGNADO",
              datos
            );
            this.comprobanteSinAsignacionRechazadoNoParticipo(datos);
          }
          break;
        case "SIN_ASIGNACION_FINAL":
          datos.periodo = 4;
          this.cabeceraComprobante("NO ASIGNADO", datos);
          this.comprobanteSinAsignacionComplementario(datos);
          break;
        case "NO_CORRE_LISTA_ESPERA_SIN_ASIGNACION":
          datos.periodo = 4;
          this.cabeceraComprobante("NO ASIGNADO", datos);
          this.comprobanteSinAsignacionPeriodosAnterioresNoParticiaComplementario(
            datos
          );
          break;
        default:
          break;
      }
      PdfDocument.openSinglePage(nombreDocumento);
      PdfDocument.reset();
    },
    generarURLqr() {
      let origen = this.url;
      let urlQr = "";
      if (!origen) {
        origen = "http://nc-ext-ibraramo.mineduc.cl:8060/";
        urlQr = origen + "validar-resultado?resultado=" + this.jwt;
      } else {
        urlQr = origen + CONTEXT + "/validar-resultado?resultado=" + this.jwt;
      }
      //console.log(urlQr);
      return urlQr;
    },
    cabeceraComprobante(titulo, datos) {
      let apoderado = {
        rutApoderado: datos.runApoderado,
        dvApoderado: datos.dvApoderado,
        nombreApoderado: datos.nombreApoderado,
        paternoApoderado: datos.paternoApoderado,
        maternoApoderado: datos.maternoApoderado ? datos.maternoApoderado : ""
      };
      let fecha = new Date();
      let fechaDescarga = `${fecha.getDate()}/${fecha.getMonth() +
        1}/${fecha.getFullYear()} ${fecha.getHours()}:${fecha.getMinutes()}:${fecha.getSeconds()}`;
      PdfDocument.createTitle(
        titulo,
        fechaDescarga,
        datos.id,
        true,
        datos.periodo
      );
      PdfDocument.createPostulante(datos.postulante);
      PdfDocument.createApoderado(apoderado);
    },
    comprobanteSinAsignacionPeriodosAnterioresNoParticiaComplementario(datos) {
      let datosComprobante = {
        titulo: "",
        tipo: "sinAsignacionOtroPeriodo",
        preferenciaAdmitido: null,
        postulante: datos.postulante,
        fechaModificacion: datos.fechaModificacion,
        tipoDetalle: "sinAsignacionOtroPeriodo"
      };
      PdfDocument.createMarcoSinDivisiones(datosComprobante);
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_B"
      );
    },
    comprobanteSinAsignacionComplementario(datos) {
      let datosComprobante = {
        titulo: "",
        tipo: "sinAsignacionComplementario",
        preferenciaAdmitido: null,
        postulante: datos.postulante,
        fechaModificacion: datos.fechaModificacion,
        tipoDetalle: "sinAsignacion"
      };
      PdfDocument.createMarcoSinDivisiones(datosComprobante);
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_B"
      );
    },
    comprobanteSinAsignacionRechazadoNoParticipo(datos) {
      let datosComprobante = {
        titulo: "",
        tipo: "sinAsignacionRechazadoSinComplementario",
        preferenciaAdmitido: null,
        postulante: datos.postulante,
        fechaModificacion: datos.fechaModificacion,
        tipoDetalle: "sinAsignacionRechazadoSinComplementario"
      };
      PdfDocument.createMarcoSinDivisiones(datosComprobante);
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_B"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/resultados/DescargarInstructivo.vue